import axiosInstance from "core/api/axiosInstance";
import { cycleRequestError } from "./cycleRequestError";
import {
  cycleResult,
  cycleDate,
  entryToISO,
  normalizePlate,
} from "../creacionCiclo/model/cycleModel";

export const formatDateForDisplay = cycleDate;
export const formatDateToBackendISO = (value) => {
  const match = /^(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2})(?::00)?$/.exec(value);
  if (!match) throw new Error("Fecha u hora inválida");
  return entryToISO(match[1], match[2]);
};
const assertAuth = () => {
  if (!localStorage.getItem("token"))
    throw new Error("Su sesión ha expirado. Inicie sesión nuevamente.");
};
const errorMessage = (error) =>
  error.response?.data?.message ||
  error.response?.data?.msm ||
  (error.request
    ? "No se pudo conectar con el servidor. Verifique el resultado antes de reintentar."
    : error.message) ||
  "No se pudo completar la solicitud";

export const getCycleCommerceService = async () => {
  assertAuth();
  try {
    const { data } = await axiosInstance.get("/api/automatization/get-cycle-commerce");
    const list = Array.isArray(data) ? data : data?.response;
    if (!Array.isArray(list))
      throw new Error("La respuesta de comercios no contiene una lista válida");
    return list;
  } catch (error) {
    throw new Error(errorMessage(error));
  }
};

export const createCycleService = async (cycleData) => {
  try {
    assertAuth();
    const plate = normalizePlate(cycleData.plate);
    if (!cycleData.commerce?.trim()) throw new Error("Seleccione un comercio");
    if (!/^[A-Z]{3}\d{3}$/.test(plate)) throw new Error("Formato de placa inválido. Use ABC123");
    if (!cycleData.entry || isNaN(new Date(cycleData.entry).getTime()))
      throw new Error("Fecha inválida");
    const payload = { commerce: cycleData.commerce.trim(), plate, entry: cycleData.entry };
    const { data, status } = await axiosInstance.post("/api/automatization/create-cycle", payload, {
      timeout: 30000,
    });
    const result = cycleResult(data?.response ?? data);
    // Un mensaje genérico del envoltorio no confirma la operación del reader.
    const success =
      result.severity === "success" && data?.success !== false && data?.success !== "false";
    return {
      success,
      data,
      rawResponse: data,
      payloadSent: payload,
      httpStatus: status,
      backendCode: result.code,
      backendMessage: result.message,
      message: success
        ? result.label
        : `${result.label}${result.message ? `: ${result.message}` : ""}`,
      error: success ? null : `${result.label}${result.message ? `: ${result.message}` : ""}`,
    };
  } catch (error) {
    const detail = error.response?.data?.response ?? error.response?.data;
    const result = detail ? cycleResult(detail) : null;
    return {
      success: false,
      error: cycleRequestError(error, result?.message || errorMessage(error)),
      httpStatus: error.response?.status,
    };
  }
};

export const getCyclesService = async (filters = {}) => {
  try {
    assertAuth();
    const params = new URLSearchParams();
    ["startDate", "endDate", "commerce", "plate", "search"].forEach((key) => {
      if (filters[key]) params.set(key, filters[key]);
    });
    const { data } = await axiosInstance.get(
      `/api/automatization/get-cycles/1${params.size ? `?${params}` : ""}`
    );
    const list = Array.isArray(data) ? data : data?.data;
    if (!Array.isArray(list))
      throw new Error("La respuesta del historial no contiene una lista válida");
    return { success: true, data: list, total: list.length };
  } catch (error) {
    return { success: false, error: errorMessage(error) };
  }
};
